module.exports = __webpack_public_path__ + "mobile/img/img_home_list_banner1.541c61e7.png";